import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'digi-editor',
  templateUrl: './ckeditor.component.html',
  styleUrl: './ckeditor.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CkeditorComponent implements OnInit {
  @Input() errorMessage: string = '';
  @Input() value: string = '';
  @Output() contentChanged = new EventEmitter<string>();

  content: string | undefined;
  //content: string = '';
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    minHeight: '20rem',
    maxHeight: '20rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    sanitize: false,
    toolbarPosition: 'top',
    defaultFontName: 'Arial',
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  ngOnInit(): void {
    this.content = this.value || '';
    //throw new Error('Method not implemented.');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && changes['value'].currentValue !== undefined) {
      this.content = changes['value'].currentValue;
    }
  }

  onContentChange() {
    this.contentChanged.emit(this.content); // Gửi dữ liệu lên AppComponent
  }
}
